import request from '@/utils/request'

const businessCardApi = {
  card_list: '/business_card/card/',
  card_create: '/business_card/card/',
  card_update: '/business_card/card/',
  card_delete: '/business_card/card/',
  card_detail: '/business_card/card/',
  card_publish: '/business_card/card/',
  card_disable: '/business_card/card/',
  collection_list: '/business_card/collection/',
  collection_delete: '/business_card/collection/',
  share_link_list: '/business_card/share_link/',
  share_link_create: '/business_card/share_link/',
  share_link_update: '/business_card/share_link/',
  share_link_delete: '/business_card/share_link/'
}

/**
 * 名片列表
 */
export function card_list (parameter) {
  return request({
    url: businessCardApi.card_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 创建名片
 */
export function card_create (parameter) {
  return request({
    url: businessCardApi.card_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 更新名片
 */
export function card_update (parameter, cardId) {
  return request({
    url: businessCardApi.card_update + cardId + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 删除名片
 */
export function card_delete (cardId) {
  return request({
    url: businessCardApi.card_delete + cardId + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 名片详情
 */
export function card_detail (cardId) {
  return request({
    url: businessCardApi.card_detail + cardId + '/',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 发布名片
 */
export function card_publish (cardId) {
  return request({
    url: businessCardApi.card_publish + cardId + '/publish/',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 禁用名片
 */
export function card_disable (cardId) {
  return request({
    url: businessCardApi.card_disable + cardId + '/disable/',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 名片收藏列表
 */
export function collection_list (parameter) {
  return request({
    url: businessCardApi.collection_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 删除名片收藏
 */
export function collection_delete (collectionId) {
  return request({
    url: businessCardApi.collection_delete + collectionId + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 分享链接列表
 */
export function share_link_list (parameter) {
  return request({
    url: businessCardApi.share_link_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 创建分享链接
 */
export function share_link_create (parameter) {
  return request({
    url: businessCardApi.share_link_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 更新分享链接
 */
export function share_link_update (parameter, linkId) {
  return request({
    url: businessCardApi.share_link_update + linkId + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 删除分享链接
 */
export function share_link_delete (linkId) {
  return request({
    url: businessCardApi.share_link_delete + linkId + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
